// =============================================================================
//  Core: Events
// =============================================================================

// Debounce
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.

function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

// Resize Debounced
$(window).on(
    'resize',
    debounce(function() {
        $.event.trigger('on:Resize');
    }, 150)
);

// Scroll Debounced
$(window).on(
    'scroll',
    debounce(function() {
        $.event.trigger('on:Scroll');
    }, 100)
);

// Resize Regular
$(window).resize(() => {
    $.event.trigger('on:ResizeDefault');
});

// ResizeEnd
(function() {
    let rtime;
    let timeout = false;
    const delta = 200;

    $(window).resize(function() {
        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(resizeEnd, delta);
        }
    });

    function resizeEnd() {
        if (new Date() - rtime < delta) {
            setTimeout(resizeEnd, delta);
        } else {
            timeout = false;
            $.event.trigger('on:ResizeEnd');
        }
    }
})();
